export default __webpack_public_path__ + "static/media/40year.4b7dffe8.svg";